const clientBaseUrl = process.env.REACT_APP_CLIENT_BASE_URL || "http://localhost:3000/";
const webApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5151/api/";

export { clientBaseUrl, webApiBaseUrl };
